document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});
$(document).ready(function(){
    customProduct(); 
})

function customProduct() {
if($('.product').length){
    const quantityBlock = `
        <span class="quantity">
        <span class="increase-tooltip js-increase-tooltip"
                data-trigger="manual"
                data-container="body"
                data-original-title="${translation('neniMozneZakoupitVice')}"
                aria-hidden="true"
                role="tooltip"
                data-testid="tooltip">
        </span>

        <span class="decrease-tooltip js-decrease-tooltip"
                data-trigger="manual"
                data-container="body"
                data-original-title="${translation('minimalniMnozstvi')}"
                aria-hidden="true"
                role="tooltip"
                data-testid="tooltip">
        </span>

        <label>
            <input type="number"
                name="amount"
                value="1"
                class="amount"
                autocomplete="off"
                data-decimals="0"
                step="1"
                min="1"
                max="9999"
                aria-label="${translation('mnozstvi')}"
                data-testid="cartAmount">
        </label>

        <button class="increase"
                type="button"
                aria-label="${translation('zvysitMnozstvi')}"
                data-testid="increase">
            <span class="increase__sign">+</span>
        </button>

        <button class="decrease"
                type="button"
                aria-label="${translation('snizitMnozstvi')}"
                data-testid="decrease">
            <span class="decrease__sign">−</span>
        </button>
        </span>
        `;
    $('.products:not(#productsTop) .product').each(function(){
        const $product = $(this);
        const productId = $product.find('span[data-micro="sku"]').text().trim();
        if ($(this).find('.price-standard').length>0) {
            var $prices = $(this).find('.prices');
            if (!$prices.hasClass('superPrice')) {
                $(this).find('.flag-discount').contents().filter(function() {
                    return this.nodeType === 3;
                }).each(function() {
                    this.nodeValue = this.nodeValue.replace(/\bod\s+/g, '');
                });
                $(this).find('.prices').addClass('superPrice').prepend($(this).find('.price-standard').clone());
            }
        }
        if(!$(this).find('.quantity').length){
            $(this).find('.p-tools form').prepend(quantityBlock)
        }
    })
  }
    
}